"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createObligationApi = void 0;
exports.createObligationApi = (axios) => ({
    createObligation(_a) {
        var { projectId } = _a, rest = __rest(_a, ["projectId"]);
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post(`/project/${projectId}/obligations`, rest)).data;
        });
    },
    updateObligation(_a) {
        var { obligationId, projectId } = _a, rest = __rest(_a, ["obligationId", "projectId"]);
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.put(`/project/${projectId}/obligation/${obligationId}`, rest)).data;
        });
    },
    deleteObligation({ projectId, obligationId, }) {
        return __awaiter(this, void 0, void 0, function* () {
            yield axios.delete(`/project/${projectId}/obligation/${obligationId}`);
        });
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib2JsaWdhdGlvbkFwaS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hcGkvb2JsaWdhdGlvbkFwaS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUdhLFFBQUEsbUJBQW1CLEdBQUcsQ0FBQyxLQUFvQixFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ3RELGdCQUFnQixDQUFDLEVBYXRCO1lBYnNCLEVBQ3JCLFNBQVMsT0FZVixFQVhJLElBQUksY0FGYyxhQUd0QixDQURROztZQVlQLE9BQU8sQ0FBQyxNQUFNLEtBQUssQ0FBQyxJQUFJLENBQUMsWUFBWSxTQUFTLGNBQWMsRUFBRSxJQUFJLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQzs7S0FDM0U7SUFFSyxnQkFBZ0IsQ0FBQyxFQWV0QjtZQWZzQixFQUNyQixZQUFZLEVBQ1osU0FBUyxPQWFWLEVBWkksSUFBSSxjQUhjLDZCQUl0QixDQURROztZQWFQLE9BQU8sQ0FDTCxNQUFNLEtBQUssQ0FBQyxHQUFHLENBQUMsWUFBWSxTQUFTLGVBQWUsWUFBWSxFQUFFLEVBQUUsSUFBSSxDQUFDLENBQzFFLENBQUMsSUFBSSxDQUFDOztLQUNSO0lBRUssZ0JBQWdCLENBQUMsRUFDckIsU0FBUyxFQUNULFlBQVksR0FJYjs7WUFDQyxNQUFNLEtBQUssQ0FBQyxNQUFNLENBQUMsWUFBWSxTQUFTLGVBQWUsWUFBWSxFQUFFLENBQUMsQ0FBQztRQUN6RSxDQUFDO0tBQUE7Q0FDRixDQUFDLENBQUMifQ==